/**
 * 考虑到不同业务的差异性，获取 host 作为一个函数执行以满足差异性
 */
export const host = (env = 'online') => {
    const baseURL = {
        development: 'http://apiall.hotel.test.sankuai.com',
        preview: 'https://api-flight.meituan.com',
        online: 'https://api-flight.meituan.com'
    };
    return baseURL[env];
};
